<template>
  <div class="myWallet" style="height:100%">
    <h4 class="tabBox">
      <button :class="activeName==='walletParticulars' && 'active'" @click="activeName='walletParticulars'">我的钱包</button>
      <button :class="activeName==='walletHistory' && 'active'" @click="activeName='walletHistory'">译贝历史</button>
    </h4>
    <walletParticulars v-if="activeName==='walletParticulars'"> </walletParticulars>
    <walletHistory v-if="activeName==='walletHistory'"> </walletHistory>

  </div>
</template>

<script>

import walletParticulars from "./walletParticulars.vue";
import walletHistory from "./walletHistory.vue";
export default {
  name: "myWallet",
  inject: ['reload'],
  components: {
    walletHistory,
    walletParticulars
  },
  data() {
    return {
      activeName: "walletParticulars",

    };
  },
  computed: {

  },
  created() {

  },
  updated() {

  },
  methods: {
    handleClick() {

    }
  },
};
</script>
<style lang="less" scoped>
.myWallet {
  .tabBox {
    text-align: left;
    padding-top: 8px;
    margin-bottom: 30px;
    button {
      width: 100px;
      height: 32px;
      border-radius: 4px;
    }
    button {
      background: rgba(239, 245, 254, 1);
      color: #256dff;
      border: 1px solid rgba(37, 109, 255, 1);
      margin-right: 20px;
    }
    .active{
      color: #ffffff;
      background: rgba(37, 109, 255, 1);
      border: 1px solid rgba(37, 109, 255, 1);
    }
  }
  // /deep/.el-tabs .el-tabs__content {
  //   height: calc(100% - 55px);
  // }
}
</style>